import React, { useState, useEffect } from 'react';
import './Reset.password.scss';
import InputPassword from '../forms/inputs/Input.password'

import Button from '../forms/buttons/Button';
import { useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import GraphQlClient from '../services/graphql';
import {Navigate, useParams} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";


function ResetPasswordComponent({ toaster, match, setUser }) {
    let { token } = useParams();
    const [newPassword, _setPassword] = useState('');
    const [newPasswordConfirm, _setPasswordConfirm] = useState('');
    const [passwordRecoverRedirect, setPasswordRecoverRedirect] = useState('');
    const { t } = useTranslation(['auth']);
    const [validating, setValidating] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isUsedPassword,setIsUsedPassword] = useState(false);
    const [validateToken] = useMutation(gqlSchemaLibrary.auth.mutation.validateResetToken, {
        onCompleted: ({ validateResetToken }) => {
            console.log('validateResetToken: ', validateResetToken);
            if (validateResetToken) {
                AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'validate', action: 'validate token success', resetToken: token});
                setValidated(!!validateResetToken.email);
            } else {
                AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'validate', action: 'validate token failed', resetToken: token});
                setValidated(!!validateResetToken);
            }
            setValidating(false);
        },
        onError: (error) => {
            AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'validate', action: 'validate token failed', resetToken: token});
        }
    });
    const [newPasswordSet] = useMutation(gqlSchemaLibrary.auth.mutation.newPasswordSet, {
        onCompleted: ({ newPasswordSet }) => {
            console.log('newPasswordSet: ', newPasswordSet);
            if(newPasswordSet.isUsed){
                AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'onSubmit', action: 'reset password failed', resetToken: token});
                setIsUsedPassword(true)
                console.log('Passowrd used')
            }
            else{
                AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'onSubmit', action: 'reset password success', resetToken: token});
                setIsUsedPassword(false)
                GraphQlClient.login(newPasswordSet.user.email, newPassword)
                    .then(meUser => {
                        setUser(meUser);
                    })
            }
        },
        onError: (error) => {
            AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'onSubmit', action: 'reset password failed', resetToken: token});
        }
    });

    useEffect(() => {
        console.log('token: ', token);
        setValidating(true);
        validateToken({
            variables: {
                resetToken: token
            }
        })
    }, [token, validateToken])

    const submitReset = (e) => {
        e.preventDefault();
        AuditTrail.sendLog(PAGES.RESET_PASSWORD, {event: 'click', action: 'button reset password', resetToken: token});
        if(!validated){
            setPasswordRecoverRedirect(1);
            return;
        }

        if (!newPassword || !newPasswordConfirm || !(newPasswordConfirm === newPassword)) {
            return;
        }
        newPasswordSet({
            variables: {
                resetToken: token,
                newpassword: newPassword
            }
        })
    }

    const validatePassword = () => {
        if(newPassword.length < 8){
            return t('text-reset-pwd-1')
        }
        if(!newPassword.split('').some(s => /[0-9]/.test(s))){
            return t('text-reset-pwd-2')
        }
        if(!newPassword.split('').some(s => /[A-Z]/.test(s))){
            return t('text-reset-pwd-3')
        }
        if(!newPassword.split('').some(s => /[!@$%#*&]/.test(s))){
            return t('text-reset-pwd-4')
        }
        return null
    }

    const setPassword = (value) => {
        _setPassword(value);

    }
    const setPasswordConfirm = (value) => {
        _setPasswordConfirm(value);
    }

    return (
        <div id="ResetPassword">
            <form onSubmit={submitReset}>
                <div className="_title">
                    <h1>
                        {validating ? t('check-token') : (validated ? t('create-new-pwd') : t('expired-link'))}
                    </h1>
                </div>
                {
                    validating ?
                        <p className="_sent">

                        </p>
                        : (
                            !validated ?
                                <>
                                    <p className="_sent">
                                        {t('text-reset-pwd-5')}
                                        <br/>{t('text-reset-pwd-6')}
                                    </p>
                                    <Button type={'submit'} >
                                        <span>{t('continue')}</span>
                                    </Button>
                                </>
                                :
                                <>
                                    <p className="_sent">
                                        {t('text-reset-pwd-7')}
                                        <br/>
                                        {(isUsedPassword) ? t('password-used'): <span></span> }
                                    </p>
                                    <InputPassword
                                        label={t('new-pwd')}
                                        autocomplete="new-password"
                                        value={newPassword}
                                        onChange={setPassword}
                                        error={!!newPassword.length && validatePassword()}
                                        event={PAGES.RESET_PASSWORD}
                                    />
                                    <InputPassword
                                        label={t('confirm-new-pwd')}
                                        autocomplete="new-password"
                                        value={newPasswordConfirm}
                                        onChange={setPasswordConfirm}
                                        error={newPassword.length > 7 && newPasswordConfirm.length > 7 && (newPasswordConfirm !== newPassword) ? t('no-match-pwd') : false}
                                        event={PAGES.RESET_PASSWORD}
                                    />
                                    <Button type={'submit'} disabled={!newPassword || !newPasswordConfirm || !(newPasswordConfirm === newPassword) || !!validatePassword()}>
                                        <span>{t('continue')}</span>
                                    </Button>
                                </>)
                }
                {
                    passwordRecoverRedirect ? <Navigate to="/password" />: ''
                }

            </form>
        </div>
    )
}

export default PageViewLog(ResetPasswordComponent);
